<div class="card">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b">
    <h3 class="text-lg font-semibold">Approved Social Media</h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <kendo-grid [kendoGridBinding]="repState.approvedSocialMedia" [pageSize]="10" [pageable]="true"
      (edit)="editHandler($event)" (add)="addHandler($event)" (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)">
      <ng-template kendoGridToolbarTemplate>
        <button type="button" icon="plus-outline" look="flat" kendoGridAddCommand>
          Add New Record
        </button>
        <button type="button" icon="refresh-sm" look="flat" kendoButton class="display-end">
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column field="socialMedia" title="Social Media" width="250">
        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
          <input class="k-textbox k-adjust-width" [formControl]="formGroup.get(column.field)" maxlength="50"
            kendoTextBox />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="startDate" title="Start Date" width="125">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.startDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-column="column" let-formGroup="formGroup">
          <kendo-datepicker class="k-adjust-width" type="date" [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy" [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="endDate" title="End Date" width="125">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.endDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-column="column" let-formGroup="formGroup">
          <kendo-datepicker class="k-adjust-width" type="date" [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy" [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Command" width="125">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
          <button kendoGridEditCommand [primary]="true">Edit</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
            Save
          </button>
          <button kendoGridCancelCommand>Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
